import { render, staticRenderFns } from "./TableColumnSelector.vue?vue&type=template&id=554e4b32&scoped=true&"
import script from "./TableColumnSelector.vue?vue&type=script&lang=ts&"
export * from "./TableColumnSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TableColumnSelector.vue?vue&type=style&index=0&id=554e4b32&scoped=true&lang=css&"
import style1 from "./TableColumnSelector.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e4b32",
  null
  
)

export default component.exports